/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, April 13th 2022, 12:11:30 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { OSActionButton, EmptyStateActionWrapper, Image, useToggleState } from "ui-widgets";
import { NewBillingTaskTemplateForm } from "service-builder/components/workflow-builder/NewBillingTaskTemplateForm";

export const EmptyBillingConfigurationsCTA = () => {
  const { handleClose, handleOpen, open } = useToggleState();

  return (
    <>
      <EmptyStateActionWrapper
        title="No billing configurations are available for this service"
        description="Add a billing configuration by creating a billing task in this
  workflow."
        illustrationGraphic={<Image className="image-style-A" src="/img/online-payment.png" alt="Onestop Admin" />}
      >
        <OSActionButton variant="contained" size="large" onClick={handleOpen}>
          Create Billing Task
        </OSActionButton>
      </EmptyStateActionWrapper>
      <NewBillingTaskTemplateForm open={open} handleClose={handleClose} />
    </>
  );
};
